import { CSSProperties } from 'react';
import { GoBackLinkComponent, leftHeaderContainerStyle } from '@vivli/shared/components';
import { useListingRequestContext } from '@vivli/features/listing-request/infrastructure/context';
import { ListingRequestStatusEnum } from '@vivli/features/listing-request/infrastructure/enum';
import { AdminHeaderTitleView } from '@vivli/shared/views';

const titleContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'auto auto',
    rowGap: '5px ',
};
const statusStyle: CSSProperties = {
    fontWeight: 'bold',
};
const titleStyle: CSSProperties = {
    fontSize: 20,
    paddingRight: 0,
    marginRight: 0,
};

export const ListingRequestLeftHeaderComponent = () => {
    const { listingRequest } = useListingRequestContext();
    const title = listingRequest?.datasets[0]?.studyTitle || '';
    const status = ListingRequestStatusEnum[listingRequest?.status];

    return (
        <>
            <GoBackLinkComponent />
            <div style={titleContainerStyle}>
                <AdminHeaderTitleView title={title} truncateText={true} widthPerCharacter={10} style={titleStyle} />
                <div>
                    Status: <span style={statusStyle}>{status}</span>
                </div>
            </div>
        </>
    );
};
